import { inject, Service } from '@angular/core';
import {RatingUnit} from '../model/rating-unit';
import {Observable, Subject} from 'rxjs';
import {environment} from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {GoogleService} from './google-service';

@Service()
export class RatingUnitService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl + 'ratingUnit/';
  private listSizeSubject: Subject<void> = new Subject<void>();
  private quickRateUnitKey: string = 'quickRateUnit';

  getQuickRateUnit(): RatingUnit {
    const serializedUnit: string = sessionStorage.getItem(this.quickRateUnitKey)!;
    if (serializedUnit) {
      const unit = JSON.parse(serializedUnit) as RatingUnit;
      unit.response = undefined!;
      return unit;
    } else {
      return undefined!;
    }
  }

  setQuickRateUnit(unit: RatingUnit): void {
    if (unit) {
      unit.response = undefined!;
      const serialized = JSON.stringify(unit);
      sessionStorage.setItem(this.quickRateUnitKey, serialized);
    } else {
      this.clearQuickRateUnit();
    }
  }

  clearQuickRateUnit(): void {
    sessionStorage.removeItem(this.quickRateUnitKey);
  }

  getUnits(): Observable<RatingUnit[]> {
    const url = this.urlBase + 'list';
    return this.http.get<RatingUnit[]>(url, {headers: this.getRequestHeaders()});
  }

  listSizeChanged(): Observable<void> {
    return this.listSizeSubject.asObservable();
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  saveUnit(input: RatingUnit): Observable<RatingUnit> {
    const subject = new Subject<RatingUnit>();
    const url = this.urlBase + 'save';
    this.http.post<RatingUnit>(url, JSON.stringify(input), {headers: this.getPostHeaders()}).subscribe({
      next: (unit) => {
        subject.next(unit);
        this.listSizeSubject.next();
      },
      error: (error) => subject.error(error),
      complete: () => subject.complete()
    });
    return subject.asObservable();
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set('Content-Type', 'application/json');
  }

  changeUnitSequence(id: number, newSequence: string): Observable<string> {
    const url = this.urlBase + 'resequence/' + id;
    return this.http.post(url, newSequence, {headers: this.getRequestHeaders().set('Content-Type', 'text/plain'), responseType: 'text'});
  }

  deleteUnit(id: number): Observable<string> {
    const subject = new Subject<string>();
    const url = this.urlBase + id;
    this.http.delete(url, {headers: this.getRequestHeaders(), responseType: 'text'}).subscribe({
      next: (response) => {
        subject.next(response);
        this.listSizeSubject.next();
      },
      error: (error) => subject.error(error),
      complete: () => subject.complete()
    });
    return subject.asObservable();
  }

  getUnit(id: number): Observable<RatingUnit> {
    const url = this.urlBase + id;
    return this.http.get<RatingUnit>(url, {headers: this.getRequestHeaders()});
  }

}
